import { render, staticRenderFns } from "./InvoiceReport.vue?vue&type=template&id=664b2a06&"
import script from "./InvoiceReport.vue?vue&type=script&lang=js&"
export * from "./InvoiceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports